import { Group, Button, TextInput, NumberInput, Select, Switch } from '@mantine/core';

import { useCreateWithdrawalMethod } from '../hooks/use-create-withdrawal-method';

type Props = {
  onClose: () => void;
};

export const WithdrawalMethodCreateForm = (props: Props) => {
  const { onClose } = props;
  const {
    avalableCurrencies,
    form,
    // isLoading,
    handleSubmit,
  } = useCreateWithdrawalMethod(onClose);

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <TextInput
        label="Название"
        withAsterisk
        key={form.key('name')}
        {...form.getInputProps('name')}
      />
      <Select
        label="Валюта"
        withAsterisk
        data={avalableCurrencies.map((currency) => ({ value: currency, label: currency }))}
        key={form.key('currency')}
        {...form.getInputProps('currency')}
      />
      <NumberInput
        label="Минимальная сумма вывода"
        withAsterisk
        key={form.key('minAmount')}
        {...form.getInputProps('minAmount')}
      />
      <NumberInput
        label="Максимальная сумма вывода"
        withAsterisk
        key={form.key('maxAmount')}
        {...form.getInputProps('maxAmount')}
      />
      <NumberInput
        label="Процент вывода"
        withAsterisk
        key={form.key('withdrawalPercent')}
        {...form.getInputProps('withdrawalPercent')}
      />
      <NumberInput
        label="Фикс"
        withAsterisk
        key={form.key('withdrawalFee')}
        {...form.getInputProps('withdrawalFee')}
      />

      <Switch
        mt={10}
        label="Активен"
        key={form.key('active')}
        {...form.getInputProps('active', { type: 'checkbox' })}
      />

      <Group justify="flex-end" mt="30">
        <Button variant="outline" onClick={() => onClose()}>
          Отменить
        </Button>
        <Button type="submit">
          Добавить
        </Button>
      </Group>
    </form>
  );
};
